import { render } from "./PlaceBid.vue?vue&type=template&id=4cfcefb7"
import script from "./PlaceBid.vue?vue&type=script&lang=js"
export * from "./PlaceBid.vue?vue&type=script&lang=js"
script.render = render

export default script